'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _url = require('url');

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import PlaceList from './PlaceList';

// TODO: the visual is almost the same with PlaceList, consider integrate it after the design is finalized
var Navigation = function (_React$Component) {
  (0, _inherits3.default)(Navigation, _React$Component);

  function Navigation(props) {
    (0, _classCallCheck3.default)(this, Navigation);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Navigation.__proto__ || (0, _getPrototypeOf2.default)(Navigation)).call(this, props));

    _this.state = { showAll: false };
    return _this;
  }

  (0, _createClass3.default)(Navigation, [{
    key: 'handleClick',
    value: function handleClick(e) {
      e.preventDefault();
      this.setState({ showAll: !this.state.showAll });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          i18n = _props.i18n,
          id = _props.id,
          title = _props.title,
          items = _props.items,
          location = _props.location;


      return _react2.default.createElement(
        'div',
        { className: 'hotel-list-extra-info' },
        _react2.default.createElement(
          'div',
          { className: 'title-box' },
          id ? _react2.default.createElement('span', { className: 'icon-' + id.toLowerCase().replace(/\s|\//g, '-') }) : null,
          _react2.default.createElement(
            'h3',
            null,
            title
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'content-box' },
          _react2.default.createElement(
            'div',
            { className: 'tags' },
            _react2.default.createElement(
              'div',
              { className: 'toggle-default-open' },
              items.filter(function (item) {
                return item.name;
              }).filter(function (item, index) {
                return _this2.state.showAll ? item : index < 10;
              }).map(function (item) {
                return _react2.default.createElement(
                  'div',
                  { className: 'tag', key: item.id },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: {
                        pathname: _url2.default.parse(item.pageUrl).pathname,
                        query: (0, _extends3.default)({}, location.query, { offset: 0 })
                      }
                    },
                    item.name
                  )
                );
              })
            ),
            items.length > 10 && _react2.default.createElement(
              'div',
              { className: 'more-less' },
              _react2.default.createElement(
                'a',
                { href: true, className: 'toggle-icon-box toggle-' + (this.state.showAll ? 'opened' : 'closed'), onClick: function onClick(e) {
                    return _this2.handleClick(e);
                  } },
                _react2.default.createElement(
                  'span',
                  { className: 'toggle-title' },
                  this.state.showAll ? i18n.hotelSearch.readLess : i18n.hotelSearch.readMore
                ),
                _react2.default.createElement('span', { className: 'toggle' })
              )
            )
          )
        )
      );
    }
  }]);
  return Navigation;
}(_react2.default.Component); // Navigations

Navigation.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  id: _react.PropTypes.string,
  title: _react.PropTypes.string.isRequired,
  items: _react.PropTypes.array.isRequired,
  location: _react.PropTypes.object.isRequired
};

function Navigations(props) {
  var i18n = props.i18n,
      title = props.title,
      items = props.items,
      location = props.location;


  return _react2.default.createElement(
    'div',
    { className: 'hotel-list-bottom' },
    _react2.default.createElement(
      'div',
      { className: 'full-width-box hotel-list-popular' },
      _react2.default.createElement(
        'div',
        { className: 'fluid-popular-place' },
        _react2.default.createElement(
          'div',
          { className: 'toggle-icon-box' },
          _react2.default.createElement(
            'h2',
            { className: 'toggle-title' },
            title
          )
        ),
        items[0] && items[0].pageUrl ? _react2.default.createElement(Navigation, { i18n: i18n, title: i18n.hotelSearch.seeHotelsIn, items: items, location: location }) : items.map(function (item) {
          return _react2.default.createElement(Navigation, { i18n: i18n, id: item.id, key: item.id, title: item.name, items: item.spots, location: location });
        })
      )
    )
  );
}

Navigations.propTypes = {
  i18n: _react.PropTypes.object.isRequired,
  title: _react.PropTypes.string.isRequired,
  items: _react.PropTypes.array.isRequired,
  location: _react.PropTypes.object.isRequired
};

exports.default = Navigations;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigations.js
// module id = 1208
// module chunks = 0